<script setup lang="ts">
import type { UIColor } from "@align/ui";

defineProps<{ title: string; icon?: string; color: UIColor; active?: boolean; to?: { path: string; params?: Record<string, string> } }>();

const emit = defineEmits<{ (event: "click-item"): void }>();
</script>

<template>
  <KeyValuePair direction="horizontal">
    <template #containerStart>
      <Icon v-if="icon" :id="icon" size="medium" :color="color" />
    </template>

    <template #containerEnd>
      <Copy v-if="active" type="bodyStrong" size="medium" :color="color">
        {{ title }}
      </Copy>

      <Copy v-else type="body" size="medium" :color="color">
        <NuxtLink :to="to" @click="() => emit('click-item')">
          {{ title }}
        </NuxtLink>
      </Copy>
    </template>
  </KeyValuePair>
</template>
